/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { Map, Iterable } from 'immutable';

import Button      from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Grid        from '@mui/material/Grid';

import Display from 'components/Generic/Display';
import Audio   from 'components/Generic/Inputs/Audio';
import Text    from 'components/Generic/Inputs/Text';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function AudioText({
  name = null, value = null, onChange = null, disabled = false, forced = false,
}) {
  /* –– State
   * –––––––––––––––––––––––––––––––– */
  const [state, setState] = useState(new Map());

  const mode = state.get('mode', 'audio');

  /* –– Handlers
   * –––––––––––––––––––––––––––––––– */
  function setMode(newMode) {
    setState(state.set('mode', newMode));
  }

  /* –– Effects
   * –––––––––––––––––––––––––––––––– */
  useEffect(() => {
    /**
     * The idea with the forced condition is to prevent the mode from being changed
     * when the component is forced to submit a value.
     */
    if (value?.get('blob') && mode === 'text' && !forced) {
      setMode('audio');
    } else if (value?.get('value') && mode === 'audio' && !forced) {
      setMode('text');
    }
  }, [value]);

  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <ButtonGroup color="primary" aria-label="primary button group">
          <Button variant={mode === 'audio' ? 'contained' : 'outlined'} onClick={() => setMode('audio')}>{t('eos.landing_page.label.audio')}</Button>
          <Button variant={mode === 'text' ? 'contained' : 'outlined'} onClick={() => setMode('text')}>{t('eos.landing_page.label.text')}</Button>
        </ButtonGroup>
      </Grid>
      <Grid item xs={12}>
        <Display if={mode === 'audio'}>
          <Audio
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            forced={mode === 'audio' && forced}
          />
        </Display>
        <Display if={mode === 'text'}>
          <Text
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            forced={mode === 'text' && forced}
          />
        </Display>
      </Grid>
    </Grid>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
AudioText.propTypes = {
  name:     PropTypes.string,
  value:    PropTypes.objectOf(Iterable),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  forced:   PropTypes.bool,
};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default AudioText;
